// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1__MF","cls2":"CreateSocialItem-cls2_z0r CreateSocialItem-cls1__MF"};